import { IPictogramFields } from '@/types/contentful';
import { PictogramLite } from '@greenlightme/ui/dist/v2';
import React from 'react';

export default function PictogramComponent({
  size,
  type,
  icon,
  color,
  shape,
  inverse
}: IPictogramFields) {
  return (
    <PictogramLite
      size={size}
      type={type}
      inverse={inverse}
      fileName={icon}
      color={color}
      shape={shape}
    />
  );
}
